@if (declaration?.data; as data) {
  <div>
    <div class="row">
      <div class="col-md">
        @if (!isTemplate && !isGeneric && (isContainerDeclaration || data.containerNumber)) {
          <app-form-group
            label="Container number">
            <input [readonly]="!isEditable() || !!declaration.crn" class="form-control" [(ngModel)]="data.containerNumber"
              (change)="data.containerNumber=$event.target?.value?.trim()" required
              [appCompare]="declaration.dataFromCustoms?.containerNumber" comparePreamble="Customs reported: ">
          </app-form-group>
        }
        @if (!!declaration.crn) {
          <app-form-group label="CRN">
            <input class="form-control" readonly [(ngModel)]="declaration.crn">
          </app-form-group>
        }
        @if (!isGeneric) {
          <app-form-group label="Country of export">
            <app-search [required]="!isTemplate" [minCharacters]="1"
              [(ngModel)]="data.countryOfExport"
              [searchFunction]="refData.findCountries"
              dataKey="code" [resultFormatter]="refData.countryFormatter"
              [appCompare]="declaration.dataFromCustoms?.countryOfExport" comparePreamble="Customs reported: "
              [compareFormatter]="refData.countryCompareFormatter"
              [disabled]="!isEditable()">
            </app-search>
          </app-form-group>
        }
        @if (!isGeneric) {
          <app-form-group label="Terminal of discharge">
            <app-search [disabled]="!isEditable() || !!declaration.crn" [ngModel]="data.dischargeTerminal"
              (ngModelChange)="setTerminal($event)" [inputFormatter]="refData.terminalFormatter"
              [searchFunction]="refData.findTerminals" dataKey="terminalCode" placeholder="Search for terminal">
            </app-search>
          </app-form-group>
        }
        <app-form-group label="Departure office">
          <app-select [(ngModel)]="data.departureOffice" [required]="!isTemplate"
            [optionsProvider]="refData.getTransitOffices()" [nullOption]="true"
            [disabled]="!isEditable()"
            dataKey="unCode" [formatter]="refData.transitOfficesFormatter"
            [appCompare]="declaration.dataFromCustoms?.departureOffice" comparePreamble="Customs reported: "
            [compareFormatter]="refData.transitOfficesCompareFormatter">
          </app-select>
        </app-form-group>
        @if (!isGeneric) {
          <app-form-group label="Place of Loading">
            <label [ngClass]="{'required': !isTemplate}">Place of Loading</label>
            <input class="form-control" placeholder="Enter zip code + number"
              [required]="!isTemplate"
              [(ngModel)]="data.placeOfLoading" [disabled]="!!data.dischargeTerminal?.organisationShortName"
              [readOnly]="!isEditable()" [minlength]="1" [maxlength]="17"
              [appCompare]="declaration.dataFromCustoms?.placeOfLoading" comparePreamble="Customs reported: ">
          </app-form-group>
        }
        @if (!isGeneric) {
          <app-form-group>
            <label [ngClass]="{'required': !isTemplate}">Authorized location</label>
            <input class="form-control" placeholder="Enter zip code + number"
              [required]="!isTemplate" [(ngModel)]="data.authorizedLocation"
              pattern="[1-9][0-9]{3} [a-z | A-Z]{2}( \w*)?"
              title="e.g. '3000 AA 15b', zipCode and number separated with spaces"
              [readOnly]="!isEditable()"
              [appCompare]="declaration.dataFromCustoms?.authorizedLocation" comparePreamble="Customs reported: ">
          </app-form-group>
        }
        <app-form-group label="Transit offices">
          <app-multi-search [(ngModel)]="data.transitOffices" [searchFunction]="refData.findTransitOffices"
            [disabled]="!isEditable()"
            [required]="transitOfficesRequired()"
            [inputFormatter]="refData.transitOfficesFormatter" [minCharacters]="2"
            placeholder="Find office">
          </app-multi-search>
        </app-form-group>
        <app-form-group label="Destination office">
          <app-search [(ngModel)]="data.destinationsOffice" [required]="!isTemplate"
            [searchFunction]="refData.findTransitOffices" [resultFormatter]="refData.transitOfficesFormatter"
            [inputFormatter]="refData.transitOfficesFormatter" [minCharacters]="2"
            dataKey="unCode"
            [disabled]="!isEditable()"
            [appCompare]="declaration.dataFromCustoms?.destinationsOffice" comparePreamble="Customs reported"
            [compareFormatter]="refData.transitOfficesCompareFormatter">
          </app-search>
        </app-form-group>
        <app-form-group label="Country of destination">
          <app-search [required]="!isTemplate" [minCharacters]="1"
            [(ngModel)]="data.countryOfDestination"
            [searchFunction]="refData.findCountries"
            dataKey="code" [resultFormatter]="refData.countryFormatter"
            [disabled]="!isEditable()" [appCompare]="declaration.dataFromCustoms?.countryOfDestination"
            comparePreamble="Customs reported: " [compareFormatter]="refData.countryCompareFormatter">
          </app-search>
        </app-form-group>
        @if (!isTemplate) {
          <app-form-group>
            <label>UCR
              <app-info [wide]="true">
                <span class="tooltipContent text-start">Unique consignment reference</span>
              </app-info>
            </label>
            <input class="form-control" placeholder="Unique consignment reference" [readonly]="!isEditable()"
              [(ngModel)]="data.ucr"
              [appCompare]="declaration.dataFromCustoms?.ucr" comparePreamble="Customs reported: ">
          </app-form-group>
        }
      </div>
      <div class="col-md">
        @if (!isTemplate && !isGeneric) {
          <app-form-group label="LRN">
            <input class="form-control" readonly [(ngModel)]="declaration.lrn">
          </app-form-group>
        }
        @if (!!declaration.status?.mrn) {
          <app-form-group label="MRN">
            <input class="form-control" readonly [(ngModel)]="declaration.status.mrn">
          </app-form-group>
        }
        <app-form-group label="Declaration type">
          <app-select [required]="!isTemplate" [(ngModel)]="data.type"
            [appDefaultValue]="{code: 'T1', description: 'External Community Transit'}"
            [optionsProvider]="refData.transitTypes()" dataKey="code"
            [disabled]="!isEditable()"
            [formatter]="refData.transitTypeFormatter" placeholder="– Select a transit type –"
            [appCompare]="declaration.dataFromCustoms?.type" comparePreamble="Customs reported: "
            [compareFormatter]="refData.transitTypeCompareFormatter">
          </app-select>
        </app-form-group>
        @if (!isTemplate && displaySendDate) {
          <app-transit-declaration-send-trigger-info [declaration]="declaration"
            [readonly]="!isEditable()" (changed)="recalculateExpiryDate()"
            [sendOnAtaEnabled]="!!declaration.crn" [includeSealsEnabled]="false">
          </app-transit-declaration-send-trigger-info>
        }
        <app-form-group>
          <label>License number
            <app-info [wide]="true">
              <span class="tooltipContent text-start">The license number for the simplified procedure</span>
            </app-info>
          </label>
          <input class="form-control" placeholder="Enter the declarant license number" [readonly]="!isEditable()" required
            [(ngModel)]="data.declarantLicenseNumber"
            [appCompare]="declaration.dataFromCustoms?.declarantLicenseNumber" comparePreamble="Customs reported: ">
        </app-form-group>
        <app-form-group>
          <label [ngClass]="{'required': true}">Transport term</label>
          <app-days [(ngModel)]="declaration.data.transportTerm" (change)="recalculateExpiryDate()"
            [readonly]="!isEditable()"
          [required]="true"></app-days>
        </app-form-group>
        @if (!declaration.transportExpiryDate && !this.declaration.status.sendOnAta && !isTemplate &&
          !isGeneric) {
          <app-form-group label="Requested Expiry date">
            <app-date-field
              [ngModel]="declaration.requestedTransportExpiryDate"
            [disabled]="true" [dateOnly]="true"></app-date-field>
          </app-form-group>
        }
        @if (declaration.transportExpiryDate && !isTemplate && !isGeneric) {
          <app-form-group label="Expiry date">
            <app-date-field
              [ngModel]="transportExpiryDate" [appCompare]="requestedTransportExpiryDate"
              comparePreamble="You reported: "
            [disabled]="true" [dateOnly]="true"></app-date-field>
          </app-form-group>
        }
        @if (!isTemplate && !isGeneric) {
          <app-form-group label="Conveyance reference">
            <input class="form-control" placeholder="e.g. vessel name"
              [readonly]="!isEditable()"
              [(ngModel)]="data.conveyanceReference" [appCompare]="declaration.dataFromCustoms?.conveyanceReference"
              comparePreamble="Customs reported: ">
          </app-form-group>
        }
        @if (!isGeneric) {
          <app-form-group>
            <label>Seals</label>
            <app-tags [(ngModel)]="data.seals" placeholder="Add Seal" [readonly]="!isEditable()"></app-tags>
          </app-form-group>
        }
        <app-form-group label="Representative">
          <input class="form-control" placeholder="e.g. full name" [(ngModel)]="data.representative"
            [appCompare]="declaration.dataFromCustoms?.representative"
            [readonly]="!isEditable()"
            comparePreamble="Customs reported: ">
        </app-form-group>
        <app-form-group label="Representative EORI">
          <input class="form-control" placeholder="The EORI number of the representative"
            [(ngModel)]="data.representativeEori" [appCompare]="declaration.dataFromCustoms?.representativeEori"
            [readonly]="!isEditable()" comparePreamble="Customs reported: ">
        </app-form-group>
        <app-form-group>
          <label>Binding itinerary
            <app-info [wide]="true">
              <span class="tooltipContent text-start">
                Only use this if the customs office of departure demands a specific route
              </span>
            </app-info>
          </label>
          <app-yes-no [(ngModel)]="data.bindingItinerary" (ngModelChange)="updateItinerary()" [disabled]="!isEditable()">
          </app-yes-no>
        </app-form-group>
        @if (isItineraryAllowed()) {
          <app-form-group label="Itinerary">
            @for (country of data.itinerary; track country; let index = $index; let last = $last) {
          <app-search class="mb-2" [ngModel]="country" (ngModelChange)="$event?.code ?
          data.itinerary[index] = $event.code : data.itinerary.splice(index, 1)"
                [searchFunction]="refData.findCountries" [resultFormatter]="refData.countryFormatter"
                [minCharacters]="1" [disabled]="!isEditable()" [required]="data.bindingItinerary && !isTemplate">
              </app-search>
              @if (last) {
                <app-search [ngModel]="null" placeholder="Add other"
                  (ngModelChange)="($event?.code ? data.itinerary.push($event.code) : null);"
                  [searchFunction]="refData.findCountries" [resultFormatter]="refData.countryFormatter"
                  [disabled]="!isEditable()"
                  [minCharacters]="1">
                </app-search>
              }
            }
            @if (data.itinerary && data.itinerary.length === 0) {
              <app-search [ngModel]="null" [placeholder]="data.itinerary.length === 0 ? '' : 'Add other'"
                (ngModelChange)="($event?.code ? data.itinerary.push($event.code) : null);"
                [searchFunction]="refData.findCountries" [resultFormatter]="refData.countryFormatter"
                [minCharacters]="1" [disabled]="!isEditable()" [required]="!isTemplate">
              </app-search>
            }
          </app-form-group>
        }
        <app-form-group label="Carrier remarks">
          <textarea class="form-control" [(ngModel)]="data.carrierRemarks"
          [readonly]="!isEditable()"></textarea>
        </app-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <div class="declaration-block">
          <h2>Departure transport</h2>
        </div>
        <app-form-group>
          <label>
            Transport mode
            @if (showModeOfTransportWarning(data.departureTransport.modeOfTransport)) {
              <app-info
                [wide]="true"
                iconClass="fa-triangle-exclamation"
                style="color: #ffcc00;">
                <span class="tooltipContent text-start">Setting transport mode to
                  "{{ refData.enumFormatter("NOT_SPECIFIED") }}" requires a manual call to the customs to specify the
                transport mode when the transit is in accepted state</span>
              </app-info>
            }
          </label>
          <app-select [(ngModel)]="data.departureTransport.modeOfTransport"
            [options]="refData.transitModesOfTransport" [formatter]="refData.enumFormatter"
            [appCompare]="declaration.dataFromCustoms?.departureTransport?.modeOfTransport"
            [disabled]="!isEditable()"
            [required]="true"
          comparePreamble="Customs reported: " [compareFormatter]="refData.enumFormatter"></app-select>
        </app-form-group>
        <app-form-group label="Nationality">
          <app-search [(ngModel)]="data.departureTransport.nationality" [minCharacters]="1"
            [searchFunction]="refData.findCountries"
            dataKey="code" [resultFormatter]="refData.countryFormatter"
            [appCompare]="declaration.dataFromCustoms?.departureTransport?.nationality"
            [disabled]="!isEditable()" required
            comparePreamble="Customs reported: " [compareFormatter]="refData.countryCompareFormatter">
          </app-search>
        </app-form-group>
        <app-form-group>
          <label [ngClass]="{'required': !!data.departureTransport.modeOfTransport}">Reference</label>
          <input class="form-control" [(ngModel)]="data.departureTransport.reference"
            [required]="!!data.departureTransport.modeOfTransport"
            [readonly]="!isEditable()"
            [appCompare]="declaration.dataFromCustoms?.departureTransport?.reference"
            [maxlength]="27"
            comparePreamble="Customs reported: ">
        </app-form-group>
      </div>
      <div class="col-md">
        <div class="declaration-block">
          <h2>Border transport</h2>
        </div>
        <app-form-group label="Transport mode">
          <app-select [(ngModel)]="data.borderTransport.modeOfTransport"
            [options]="refData.transitModesOfTransport" [formatter]="refData.enumFormatter"
            [appCompare]="declaration.dataFromCustoms?.borderTransport?.modeOfTransport"
            [disabled]="!isEditable()"
          comparePreamble="Customs reported: " [compareFormatter]="refData.enumFormatter"></app-select>
        </app-form-group>
        @if (data.borderTransport.modeOfTransport) {
          <app-form-group label="Nationality">
            <app-search [(ngModel)]="data.borderTransport.nationality" [minCharacters]="1"
              [searchFunction]="refData.findCountries"
              dataKey="code" [resultFormatter]="refData.countryFormatter"
              [appCompare]="declaration.dataFromCustoms?.borderTransport?.nationality"
              [disabled]="!isEditable()" required
              comparePreamble="Customs reported: " [compareFormatter]="refData.countryCompareFormatter">
            </app-search>
          </app-form-group>
        }
        @if (!!data.borderTransport.modeOfTransport) {
          <app-form-group label="Reference" required>
            <input class="form-control" [(ngModel)]="data.borderTransport.reference"
              [required]="!!data.borderTransport.modeOfTransport"
              [readonly]="!isEditable()"
              [appCompare]="declaration.dataFromCustoms?.borderTransport?.reference"
              [maxlength]="27"
              comparePreamble="Customs reported: ">
          </app-form-group>
        }
        @if (!!data.borderTransport.modeOfTransport) {
          <app-form-group label="Customs office">
            <app-search [(ngModel)]="data.borderTransport.customsOffice" [searchFunction]="refData.findTransitOffices"
              [disabled]="!isEditable()" [required]="!isTemplate"
              [inputFormatter]="refData.transitOfficesFormatter" [minCharacters]="2" placeholder="Find office">
            </app-search>
          </app-form-group>
        }
      </div>
    </div>
    <div>
      <div class="declaration-block my-4">
        <h2>Parties</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <app-form-group label="Consignee">
          <app-search [(ngModel)]="data.consignee" [required]="!isTemplate"
            [minCharacters]="1" [newValueTemplate]="newTransitParty" valueType="transit party"
            [disabled]="!isEditable()"
            [searchFunction]="findTransitParties" [inputFormatter]="refData.transitPartyFormatter">
          </app-search>
        </app-form-group>
      </div>
      <div class="col-md">
        <app-form-group>
          <label>Consignor
            <app-info [wide]="true">
              <span class="tooltipContent text-start">If left blank, the declarant will be considered the consignor</span>
            </app-info>
          </label>
          <app-search [(ngModel)]="data.consignor" [minCharacters]="1" [newValueTemplate]="newTransitParty"
            valueType="transit party" [disabled]="!isEditable()" [searchFunction]="findTransitParties"
            [inputFormatter]="refData.transitPartyFormatter">
          </app-search>
        </app-form-group>
      </div>
    </div>
    <!--loop over all guarantees-->
    <div>
      <div class="declaration-block my-4">
        <h2>Transit guarantees</h2>
      </div>
    </div>
    @for (guaranteeData of data.guarantees; track guaranteeData; let idx = $index) {
      <div class="my-2">
        <app-collapse [collapse]="guaranteeTemplate" [showOnLoad]="!guaranteeData.type"
          [deleteHandle]="isEditable() ? removeGuarantee(guaranteeData) : null"
          [validationModel]="guaranteeData">
          <div class="row  py-1 px-3 align-items-center text-dark">
            <div class="col-auto d-none d-md-block" style="min-width: 16rem">
              <span class="d-inline-block align-top text-truncate"
                [title]="guaranteeData.guaranteeReferenceNumber ? 'Guarantee reference number' :
                guaranteeData.otherReference ? 'Other reference' : 'Transit guarantee'">{{
                guaranteeData.type?.grnRequired ? guaranteeData.guaranteeReferenceNumber || 'New document' :
                guaranteeData.type?.otherReferenceRequired ? guaranteeData.otherReference || 'New document' :
                guaranteeData.otherReference || guaranteeData.type?.description || 'New document'
              }}</span>
            </div>
            @if (guaranteeData.accessCode) {
              <div class="col-auto d-none d-md-block">
                <span class="ms-1" title="Access code">{{ guaranteeData.accessCode }}</span>
              </div>
            }
            <div class="text-end col d-none d-md-block">
              <span class="mx-2" title="Customs amount">
                {{ guaranteeData.customsValue?.amount | number: '1.2-2' }}
                {{ guaranteeData.customsValue?.currency?.unCode }}
              </span>
            </div>
          </div>
        </app-collapse>
        <ng-template #guaranteeTemplate>
          <div class="collapse">
            <div class="mx-3 pt-3">
              <div class="row">
                <div class="col-md">
                  <app-form-group label="Guarantee">
                    <app-select [ngModel]="guaranteeData" (ngModelChange)="setTransitGuarantee($event, idx)"
                      [formatter]="transitGuaranteeFormatter" [options]="allTransitGuarantees"
                            [dataKey]="guaranteeData.guaranteeReferenceNumber ? 'guaranteeReferenceNumber' :
                            (guaranteeData.otherReference ? 'otherReference' : 'type')"
                      [disabled]="!isEditable()"
                      placeholder="– Select a transit guarantee –" [required]="!isTemplate"
                      id="transitguarantee">
                    </app-select>
                  </app-form-group>
                  @if (guaranteeData.guaranteeReferenceNumber) {
                    <app-form-group label="Access code">
                      <input class="form-control" readonly [(ngModel)]="guaranteeData.accessCode">
                    </app-form-group>
                  }
                </div>
                <div class="col-md">
                  <app-form-group label="Customs amount">
                    <div class="input-group">
                      <div class="me-1">
                        <app-select [ngModel]="guaranteeData.customsValue?.currency"
                          (ngModelChange)="guaranteeData.customsValue = (guaranteeData.customsValue || $any({})); guaranteeData.customsValue.currency = $event"
                          dataKey="unCode" [required]="!!guaranteeData.customsValue?.amount"
                          [optionsProvider]="refData.getCurrencies"
                          [disabled]="!isEditable()"
                          [formatter]="refData.currenciesFormatter"
                          [selectedFormatter]="refData.compactCurrenciesFormatter"
                          style="max-width: 5rem">
                        </app-select>
                      </div>
                      <input [ngModel]="guaranteeData.customsValue?.amount" placeholder="Balance amount"
                        (ngModelChange)="guaranteeData.customsValue = (guaranteeData.customsValue || $any({})); guaranteeData.customsValue.amount = $event"
                        [required]="!!guaranteeData.customsValue?.currency"
                        [readonly]="!isEditable()"
                        appDecimalNumber [maxDecimals]="2" class="form-control rounded">
                    </div>
                  </app-form-group>
                  @if (guaranteeData && guaranteeData.country) {
                    <app-form-group label="Country">
                      <div class="input-group">
                        <div class="me-1">
                          <input class="form-control" readonly [(ngModel)]="guaranteeData.country.code">
                        </div>
                        <input class="form-control" readonly [(ngModel)]="guaranteeData.country.name">
                      </div>
                    </app-form-group>
                  }
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    }
    @if (isEditable()) {
      <div class="row align-items-center">
        <div class="col-auto ms-auto">
          <ul class="nav">
            <li class="nav-item">
              <a href="#" class="nav-link p-0" (click)="$event.preventDefault(); addGuarantee()">
                <span class="pe-2 fa fa-plus-circle"></span>Add transit guarantee</a>
              </li>
            </ul>
          </div>
        </div>
      }
      <div>
        <div class="declaration-block my-4">
          <h2>notifications</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <app-form-group>
            <label>MRN sent to terminal</label>
            <input class="form-control" placeholder="Enter e-mail address"
              [readonly]="!isEditable()"
              [(ngModel)]="data.emailAddressMrnToTerminal">
          </app-form-group>
          <app-form-group>
            <label>MRN sent to terminal (copy)</label>
            <app-multi-input [(ngModel)]="data.emailAddressesMrnToTerminalForCopy"
              [disabled]="!isEditable()"
            placeholder="Enter e-mail address"></app-multi-input>
          </app-form-group>
          <app-form-group>
            <label>Container is in transit</label>
            <input class="form-control" placeholder="Enter e-mail address"
              [readonly]="!isEditable()"
              [(ngModel)]="data.emailAddressContainerInTransit">
          </app-form-group>
          <app-form-group>
            <label>Container is in transit (copy)</label>
            <app-multi-input [(ngModel)]="data.emailAddressesContainerInTransitForCopy"
              [disabled]="!isEditable()"
            placeholder="Enter e-mail address"></app-multi-input>
          </app-form-group>
        </div>
        <div class="col-md">
          <app-form-group>
            <label>Transport term expires
              <app-info [wide]="true">
                <span class="tooltipContent text-start">
                  Email for notification when the transport term expires within the number of days given below
                </span>
              </app-info>
            </label>
            <app-multi-input [(ngModel)]="data.emailAddressesForExpiryReminder"
              [disabled]="!isEditable()"
            placeholder="Enter e-mail address"></app-multi-input>
          </app-form-group>
          <app-form-group label="Reminder number of days before expiry">
            <input class="form-control"
              [readonly]="!isEditable()"
              [required]="data.emailAddressesForExpiryReminder && data.emailAddressesForExpiryReminder.length > 0"
              type="number" [(ngModel)]="data.expiryReminderNumberOfDaysBefore"/>
          </app-form-group>
        </div>
      </div>
      <ng-template #newTransitParty let-transitParty="model">
        <app-transit-party [model]="transitParty"></app-transit-party>
      </ng-template>
      <!--  {{data|json}}-->
    </div>
  }
